import React from 'react'

type Props = {
    changed: boolean
}

export default function ChangeIndicator(props: Props) {
    let color = props.changed ? 'bg-red-500' : 'bg-green-500'
    return <span className={`ml-2 w-2 h-2 mb-1 rounded-full ${color} inline-block`} />
}
